import React from 'react';
import { useTheme } from '../ThemeContext';
import { useCheckout } from '../CheckoutContext';
import { useT } from '../i18n/useT';

const UrgencyBanner = () => {
  const { isDark } = useTheme();
  const { startCheckout } = useCheckout();
  const t = useT();

  return (
    <div onClick={() => startCheckout('urgency_banner')} data-testid="urgency-banner" className="block cursor-pointer">
      <div
        className="urgency-banner-scroll relative overflow-hidden"
        style={{
          background: isDark
            ? 'linear-gradient(90deg, #0a0d14 0%, #2a3344 50%, #0a0d14 100%)'
            : 'linear-gradient(90deg, #1B2A4A 0%, #2d4a7a 50%, #1B2A4A 100%)',
          padding: '10px 0',
          cursor: 'pointer',
        }}
      >
        <div className="urgency-marquee whitespace-nowrap">
          {[...Array(4)].map((_, i) => (
            <span
              key={i}
              className="inline-block mx-8 text-[13px] sm:text-[14px] font-bold tracking-wide uppercase"
              style={{
                fontFamily: '"Inter", sans-serif',
                color: '#F4F7FB',
              }}
            >
              <span className="inline-block animate-pulse mr-2">&#x1F525;</span>
              {t.urgency.offer} — {t.urgency.price} — {t.urgency.wontLast}
              <span className="inline-block mx-4 opacity-50">|</span>
              {t.urgency.discount} — {t.urgency.priceWillIncrease}
              <span className="inline-block mx-4 opacity-50">|</span>
              {t.urgency.members}
              <span className="inline-block animate-pulse ml-2">&#x1F525;</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UrgencyBanner;
